import React from 'react'
import ApartmentOnboarding from '../feature/ApartmentOnboarding/ApartmentOnboarding'
import { ToastContainer } from 'react-toastify'

const ApartmentOnboardingPage = () => {
  return <>
    <ToastContainer />
    <ApartmentOnboarding />
  </>
}

export default ApartmentOnboardingPage